import React from 'react';
import { ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { ordensTransporteService } from '../../services';

export const OrdensTransporteFormPage: React.FC = () => {
  return (
    <ResourceFormPage
      title="Ordem de Transporte"
      service={ordensTransporteService}
      redirectPath="/admin/logistica/ordens-transporte"
      fields={[
        { name: 'caminhao', label: 'Caminhão', type: 'select', required: true },
        { name: 'reboque', label: 'Reboque', type: 'select' },
        { name: 'motorista', label: 'Motorista', type: 'select' },
        { name: 'origem', label: 'Origem', type: 'text', required: true },
        { name: 'destino', label: 'Destino', type: 'text', required: true },
        { name: 'carga_descricao', label: 'Descrição da Carga', type: 'textarea' },
        { name: 'peso_carga_kg', label: 'Peso da Carga (kg)', type: 'number' },
        { name: 'volume_carga_m3', label: 'Volume da Carga (m³)', type: 'number' },
        { name: 'data_saida', label: 'Data de Saída', type: 'date', required: true },
        { name: 'data_chegada', label: 'Data de Chegada', type: 'date' },
        { name: 'status', label: 'Status', type: 'select', options: [
          { value: 'PLANEJADA', label: 'Planejada' },
          { value: 'EM_TRANSITO', label: 'Em Trânsito' },
          { value: 'CONCLUIDA', label: 'Concluída' },
          { value: 'CANCELADA', label: 'Cancelada' },
        ]},
        { name: 'observacoes', label: 'Observações', type: 'textarea' },
      ]}
    />
  );
};
